// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3Rfim","options":"AnswerScale_options__16jTg","selected":"AnswerScale_selected__3El1Y"};